import { Generation, Response } from "@/models/models";

export const ErrorResponse = (error: any) => {
  return { success: false, message: error, data: null };
};

export function isGeneration(response: Generation | Response): response is Generation {
  return (response as Generation).generation_state !== undefined;
}